'use client'

import DefaultAlertDialog from '@/components/DefaultAlertDialog'
import { useAuthContext } from '@/context/AuthContext'
import { useTranslations } from 'next-intl'

type SignInConfirmModalProps = {
  open?: boolean
  onClose?: () => void
  content: string
  container?: HTMLElement | null
}

export default function SignInConfirmModal({
  open = false,
  onClose = () => {},
  content,
  container,
}: SignInConfirmModalProps) {
  const t = useTranslations()
  const { handleLogin } = useAuthContext()

  const handleAction = () => {
    handleLogin({ callback: window.location.href })
    onClose()
  }

  return (
    <DefaultAlertDialog
      open={open}
      type="custom"
      title={t('sign-in-confirm-modal.title')}
      container={container}
      content={<p className="body1-omni-styles text-vive-primary-20">{content}</p>}
      cancelText={t('sign-in-confirm-modal.cancel')}
      actionText={t('sign-in-confirm-modal.action')}
      onCancel={onClose}
      onAction={handleAction}
      cancelButtonClassName="rounded-full px-5 py-3 border-[1.5px] border-vive-primary-20 text-vive-primary-20 buttonM-omni-styles hover:border-vive-primary-40 hover:text-vive-primary-40 active:text-vive-primary-60 active:border-vive-primary-60"
      actionButtonClassName="rounded-full px-5 py-3 text-white buttonM-omni-styles bg-[#f53232] hover:bg-[#d42a2a] active:bg-[#b32424] "
      allowOutsideInteraction={true}
    />
  )
}
